import { Heading, Text, Skeleton, Stack } from '@chakra-ui/core'
import React from 'react'
import { PageWrap } from '../../layouts'
import {
  PopularTaskDefinitionEntityWithCount,
  TaskDefinitionEntity,
  useGetBaoriderProjectsQuery,
  useGetBaoverifierMostPopularTaskDefinitionsQuery,
  useGetBaoverifierTaskDefinitionsQuery
} from '../../generated/graphql'
import { ProjectFilters, TasksList } from './components'
import { SearchBar } from '../../components'

const ReportTasks = () => {
  const [searchQuery, setSearchQuery] = React.useState<string>('')
  const [selectedProject, setSelectedProject] = React.useState<string | null>(null)
  const [selectedTask, setSelectedTask] = React.useState<string | null>(null)
  const { data, loading } = useGetBaoriderProjectsQuery({
    fetchPolicy: 'network-only'
  })
  const projects = data?.getBaoriderProjects || []
  const { data: popularTasksData, loading: popularTasksLoading } =
    useGetBaoverifierMostPopularTaskDefinitionsQuery({
      fetchPolicy: 'network-only'
    })

  const { data: tasksData } = useGetBaoverifierTaskDefinitionsQuery({
    variables: {
      filters: {
        ...(searchQuery && {
          $or: [
            {
              project: {
                name: {
                  $contains: searchQuery
                }
              }
            },
            {
              taskType: {
                title: {
                  $contains: searchQuery
                }
              }
            }
          ]
        }),
        ...(selectedProject && {
          project: {
            id: {
              $eq: selectedProject
            }
          }
        })
      }
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })
  const popularTask = popularTasksData?.getBaoverifierMostPopularTaskDefinitions || []
  const tasks = tasksData?.getBaoverifierTaskDefinitions || []

  return (
    <PageWrap title="Report Tasks">
      <SearchBar
        placeholder="Search tasks ..."
        mb={4}
        fontSize="sm"
        onSearch={(query) => {
          setSearchQuery(query)
        }}
      />
      {projects.length > 0 && (
        <ProjectFilters
          projects={projects}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        />
      )}

      {!searchQuery && !selectedProject ? (
        <>
          <Heading as="h2" size="sm" mb={4}>
            Most Used Tasks
          </Heading>
          {popularTasksLoading ? (
            <Stack spacing={4} mb={8} direction="row" flexWrap="wrap">
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton key={index} height={150} w={210} my="10px" rounded="md" />
              ))}
            </Stack>
          ) : popularTask.length > 0 ? (
            <TasksList
              tasks={popularTask as PopularTaskDefinitionEntityWithCount[]}
              setSelectedTask={setSelectedTask}
              selectedTask={selectedTask}
            />
          ) : (
            <Text fontSize="sm" color="gray.500">
              No popular tasks found.
            </Text>
          )}

          <Heading as="h2" size="sm" mt={8} mb={4}>
            All Tasks
          </Heading>
        </>
      ) : null}
      {searchQuery && (
        <Text mb={4} fontSize="sm">
          Search Results for <b>&quot;{searchQuery}&quot;</b>
        </Text>
      )}

      {loading ? (
        <Stack spacing={3} mb={8}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} height={80} rounded="md" />
          ))}
        </Stack>
      ) : tasks.length > 0 ? (
        <TasksList
          tasks={tasks as TaskDefinitionEntity[]}
          setSelectedTask={setSelectedTask}
          selectedTask={selectedTask}
        />
      ) : (
        <Text fontSize="sm" color="gray.500">
          No tasks found matching your search criteria.
        </Text>
      )}
    </PageWrap>
  )
}

export default ReportTasks
